<div class="pagination">
  <ul>
      <li *ngFor="let item of data | paginate: {id: id, itemsPerPage: perPage, currentPage: currentPage, totalItems: total }"></li>
  </ul>

  <pagination-controls [id]="id" (pageChange)="switchPage($event)"></pagination-controls>
</div>
